import React from 'react';
export default function OurSupport() {
    const logos = [
        '/Images/our_support1.png',
        '/Images/our_support2.png',
        '/Images/our_support3.png',
        '/Images/our_support4.png', // this one is tall
    ];

    return (
        <section className="py-10 px-4 sm:px-6 lg:px-24">
            <h1 className="text-3xl text-[#3390FF] text-center mb-2">
                Supported By
            </h1>
            <div className="h-1 w-20 bg-[#3FC041] mx-auto mb-8 rounded"></div>

            <div className="flex flex-wrap justify-center items-center gap-y-4 gap-x-0 sm:gap-6">
                {logos.map((src, i) => (
                    <div
                        key={i}
                        className="w-1/2 sm:w-1/3 md:w-1/4 lg:w-1/6 p-2 flex justify-center"
                    >
                        <img
                            src={src}
                            alt={`Support logo ${i + 1}`}
                            className="w-full max-w-[220px] h-[90px] border border-gray-300 rounded-lg p-2 object-contain"
                        />
                        {/* +  <img
                  +    src={src}
                        +    alt={`Support logo ${i + 1}`}
                        +    className="w-auto max-h-[94px] border border-gray-300 rounded-lg p-2 object-contain"
                  +  /> */}
                    </div>
                ))}
            </div>
        </section>
    );
}